import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const CheckMarkIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.568 15.608L19.152 5L20.568 6.416L8.568 18.416L3 12.848L4.392 11.432L8.568 15.608Z'
                fill='currentColor'
            />
        </>
    ),
})

CheckMarkIcon.displayName = 'CheckMarkIcon'
